import {AfterViewInit, Component, Inject, Input, OnDestroy} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {filter, Observable, Subject} from 'rxjs';
import {delay, take} from 'rxjs/operators';
import {GlobalService} from '../../../../../global/global.service';
import {IGetCategoriesItemDto} from '../../../categories.dto';
import {IUploadFilesService, IUploadFilesServiceToken,} from '../../../contract-control/modals/bulk-upload-modal/upload-files.service';
import {UploadPDFUpload} from '../../../contract-control/modals/bulk-upload-modal/upload-pdf-common';
import {IDocumentTypesDto} from '../../dto/document-listing.dto';
import {DocumentListingFacade} from '../../store/document-listing.facade';
import {DocumentUploadFileApiService} from './document-upload-file.api.service';
import {MAX_DOCUMENT_UPLOAD_SIZE_BYTES} from 'app/constants/upload-limits';

@Component({
    selector: 'app-document-file-upload-modal',
    templateUrl: './document-file-upload-modal.component.html',
    styleUrl: './document-file-upload-modal.component.scss',
    providers: [{
        provide: IUploadFilesServiceToken, useExisting: DocumentUploadFileApiService
    }]
})
export class DocumentFileUploadModalComponent<P> extends UploadPDFUpload implements AfterViewInit, OnDestroy {
    private destroyed$: Subject<void> = new Subject<void>();
    private closeTimeout: NodeJS.Timeout;
    public documentTypes$: Observable<IDocumentTypesDto[]> = this._documentListingFacade.documentTypes$;
    public categories$: Observable<IGetCategoriesItemDto[]> = this._documentListingFacade.categories$;
    public selectedDocumentType: IDocumentTypesDto;
    public maxDocumentUploadSize: number = MAX_DOCUMENT_UPLOAD_SIZE_BYTES;
    public acceptDocumentFileTypes: string[] = [
                                                    "application/pdf", // .pdf
                                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
                                                    "application/msword", // .doc
                                                    "application/vnd.ms-excel", // .xls
                                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                                                    "image/jpeg", // .jpg, .jpeg
                                                    "image/png"   // .png
                                                ];


    @Input() uploadRequestParams: P;

    constructor(private _activeModal: NgbActiveModal, private _documentListingFacade: DocumentListingFacade, _formBuilder: FormBuilder, _globalService: GlobalService, _translocoService: TranslocoService, @Inject(IUploadFilesServiceToken) documentUploadFileApiService: IUploadFilesService) {
        super(_formBuilder, documentUploadFileApiService, _globalService, _translocoService);
    }

    ngAfterViewInit(): void {
        this._documentListingFacade.fetchCategories();
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();

        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }
    }

    /**
     * close the Upload modal
     */
    documentUploadFileModalClose(action: string) {
        this._activeModal.close(action);
    }

    onUploadClick() {
         super.uploadPdfFile()
            .pipe(
                filter(x => x.every(y => y.progress === 100)),
                take(1),
                delay(1000) //Make a delay to show the progress bar for all files
            )
            .subscribe({
                next:()=>{
                    this.onUploadedFiles(this.uploadForm.value.files.map(x => x.file));
                    if (this.uploadForm?.hasError('Upload files error')) {
                        delete this.uploadForm?.errors['Upload files error'];
                    }
                }
            })
    }

    onUploadedFiles(uploadedFiles: File[]) {
        this.globalService.toastrSuccess(uploadedFiles?.length >= 1 ? this.translocoService.translate('File uploaded toast (document upload files) - File has been uploaded') : this.translocoService.translate('Files uploaded toast (document upload files) - All files have been uploaded'));

        this.closeTimeout = setTimeout(() => {
            this._activeModal.close();
            this._documentListingFacade.fetchDocuments();
        }, 700);
    }


}
